import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Log } from 'app/core/logging/log';


@Component({
    selector: 'input-editable',
    templateUrl: './input-editable.component.html',
    styleUrls: ['./input-editable.component.scss']
})
export class InputEditableComponent implements OnInit {
    
    @Input() type: string = 'text';
    @Input() value: string = "";
    @Input() options: any[] = [];
    @Output() inputUpdated = new EventEmitter<any>();

    editing: boolean = false;
    
  
    constructor() {
        
    }
    
    ngOnInit(): void {
        Log.debug("InputEditableComponent options", { options:this.options });
    }

    _inputUpdated(){
        this.inputUpdated.emit(this.value);
    }

}
